module.exports = __webpack_public_path__ + "img/agenda_01.43c961b5.jpg";